export default {
  a:
    "<strong>左：</strong>◯◯◯とはときどきケンカもするし、正直ムカつくこともあります。<br/><strong>右：</strong>でももし◯◯◯が世界中を敵に回すようなことがあっても、ボクは絶対にキミの味方です。",
  b:
    "<strong>左：</strong>ボクは不器用だから、ときどきぶっきら棒に見えるかもしれません。<br/><strong>右：</strong>でも本当のことを言うと、きっと◯◯◯が思う以上にボクは◯◯◯のことを考えています。",
  c:
    "<strong>左：</strong>ボクは仕事をするということの大変さを知っています。<br/><strong>右：</strong>だから仕事と育児を両立する◯◯◯を、バケモノ（褒め言葉）だと思っています。",
  d:
    "<strong>左：</strong>ボクは放っておくと、とっても面倒くさがり屋な怠け者です。<br/><strong>右：</strong>そんなボクを日々奮起させるのは、◯◯◯△△△にカッコいい背中を見せたいって気持ちです。",
  e:
    "<strong>左：</strong>ときどきボクにも、辛くて心が折れそうになるときがあります。<br/><strong>右：</strong>そんなとき、ボクには◯◯◯△△△がいるって思うと、不思議とヤル気が湧いてくるんです。",
  f:
    "<strong>左：</strong>ボクは趣味や人付き合いの時間もゆずれない、欲張りな人間です。<br/><strong>右：</strong>でも何よりも大切な時間は、家族みんなでたわいもないことで笑っていられる時間です。",

  g:
    "<strong>左：</strong>ボクは仕事や息抜きを理由に、子育ての大半を◯◯◯に任せがちです。<br/><strong>右：</strong>仕事と育児を両立しながら、こんなボクを支えてくれる◯◯◯こそ本当の一家の大黒柱です。",
  h:
    "<strong>左：</strong>四六時中リトルギャングと格闘する子育ては、世界一の重労働だと思います。<br/><strong>右：</strong>それを見事にやってのける◯◯◯を、女性として、母として、本気でリスペクトします。",
  i:
    "<strong>左：</strong>◯◯◯は、いつだってボクの夢を応援してくれます。<br/><strong>右：</strong>だからもし◯◯◯に挑戦したい夢があるのなら、ボクは全身全霊でキミをサポートします。",
  j:
    "<strong>左：</strong>ボクには、ときどき上から目線でモノを言ってしまう悪いクセがあります。<br/><strong>右：</strong>でも◯◯◯がいないと、独りではまったく生きていけないことはちゃんと自覚しています。",

  k:
    "<strong>左：</strong>優柔不断なボクは、ときどき◯◯◯をイライラさせてしまいます。<br/><strong>右：</strong>でももしボクがウ◯コを食べないと◯◯◯が助からないようなピンチがあったら、迷わず食す覚悟です。",
  l:
    "<strong>左：</strong>知ってのとおり、ボクはゴキブリが大の苦手です。<br/><strong>右：</strong>だからヤツらに怯まず立ち向かう◯◯◯の男前な背中が、頼もしくて仕方ありません。大好きです。",
  m:
    "<strong>左：</strong>◯◯◯は菩薩みたいな笑顔で笑ったかと思うと、突然般若のような顔で怒ります。<br/><strong>右：</strong>そのギャップも魅力の一つなんですが、どちらかというとボクは菩薩派です。",
  n:
    "<strong>左：</strong>◯△◯は、ママが好きなものが大好きです。<br/><strong>右：</strong>だから、いつまでも◯◯◯に好きでいてもらえるように、ボクはこれからも精進します。",
  o:
    "<strong>左：</strong>◯◯◯は誰よりも落ち着く存在だから、ときどきそれに甘えてしまうボクがいます。<br/><strong>右：</strong>本当は一番伝えなきゃいけない「ありがとう」がなかなか言えなくてごめん。",
  p:
    "<strong>左：</strong>ボクは食べることが好きだから、外食が多いほうだと思います。<br/><strong>右：</strong>でもボクの人生最後の晩餐は、◯◯◯のつくる【あなたの好物】と決めています。",
  q:
    "<strong>左：</strong>ボクはヒトとして完璧じゃないし、弱さも汚さもたくさん持っています。<br/><strong>右：</strong>でも◯◯◯と一緒にいると、不思議なくらい穏やかでいられるから、それがとっても嬉しいんです。",
  r:
    "<strong>左：</strong>高価なレストランで食事をして、「おいしいね」って言える相手はきっと沢山います。<br/><strong>右：</strong>でもお茶漬けをすすりながら「落ち着くね」って言える相手は、ボクには◯◯◯しかいません。",
  s:
    "<strong>左：</strong>自分がどれくらい幸せか、それを誰かに説明するのってすごく難しいことです。<br/><strong>右：</strong>ただボクは、生まれ変わってもまた◯◯◯と一緒になりたいと思うくらい、とっても幸せですよ。",
  t:
    "<strong>左：</strong>ボクが好きになったのは◯◯◯です。<br/><strong>右：</strong>心優しい◯◯◯も、理不尽なことで怒る◯◯◯も、全部ひっくるめてボクが好きになった人です。",
  u:
    "<strong>左：</strong>ボクには、自分の命よりも大切な宝物が△◯△つあります。<br/><strong>右：</strong>それは、◯◯◯△△△です。"
};



// WEBPACK FOOTER //
// ./src/data/stories.js